import React from 'react';
import PropTypes from 'prop-types';
import JobDescriptionPresentation from './JobDescriptionPresentation';
import { useGetSingleJob } from '../../common/apiCalls/jobs';

export default function JobDescriptionContainer({ jobId, isMobile }) {
  const { data: jobData, isLoading: isLoadingJobData, isError: isErrorJobData } = useGetSingleJob({ jobId });

  const links =
    jobData?.locale === 'EN'
      ? [
          {
            title: 'Home Page',
            href: '/',
          },
          {
            title: 'Current Job Openings',
            href: '/jobs',
          },
          ...(jobData
            ? [
                {
                  title: jobData.title,
                  active: true,
                },
              ]
            : []),
        ]
      : [
          {
            title: 'صفحه اصلی',
            href: '/',
          },
          {
            title: 'جستجوی مشاغل',
            href: '/jobs',
          },
          ...(jobData
            ? [
                {
                  title: jobData.title,
                  active: true,
                },
              ]
            : []),
        ];

  return (
    <JobDescriptionPresentation
      breadcrumbLinks={links}
      jobData={jobData}
      isMobile={isMobile}
      jobId={jobId}
      isPageLoading={isLoadingJobData}
      isError={isErrorJobData}
    />
  );
}

JobDescriptionContainer.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  jobId: PropTypes.string.isRequired,
};
